<template>
  <div class="playlist-container">
    <div class="top-wrap">
      <div class="img-wrap">
        <img :src="playList.coverImgUrl" alt=""/>
      </div>
      <div class="info-wrap">
        <p class="title">{{ playList.name }}</p>
        <div class="author-wrap">
          <img class="avatar" :src="playList.creator.avatarUrl" alt=""/>
          <span class="name">{{ playList.creator.nickname }}</span>
          <span class="time">{{ new Date(playList.createTime).toLocaleDateString() }} 创建</span>
        </div>
        <div class="play-wrap">
          <span class="iconfont icon-circle-play"></span>
          <span class="text">播放全部</span>
        </div>
        <div class="tag-wrap">
          <span class="title">标签:</span>
          <ul v-if="playList.tags.length != 0">
            <li v-for="(item,index) in playList.tags" :key="index">{{ item }}</li>
          </ul>
        </div>
        <div class="desc-wrap">
          <span class="title">简介:</span>
          <span class="desc">{{ playList.description }}</span>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeIndex">
      <el-tab-pane label="歌曲列表" name="1">
        <table class="el-table playlit-table">
          <thead>
          <th></th>
          <th></th>
          <th>音乐标题</th>
          <th>歌手</th>
          <th>专辑</th>
          <th>时长</th>
          </thead>
          <tbody>
          <tr class="el-table__row" v-for="(item,index) in playList.tracks" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <div class="img-wrap" @click="playMusic(item.al.id)">
                <img :src="item.al.picUrl" alt=""/>
                <span class="iconfont icon-play"></span>
              </div>
            </td>
            <td>
              <div class="song-wrap">
                <div class="name-wrap">
                  <span>{{ item.name }}</span>
                  <span class="iconfont icon-mv" v-if="item.mv != 0" @click="toMvlist(item.mv)"></span>
                </div>
                <span v-if="item.alia.length != 0">{{ item.alia[0] }}</span>
              </div>
            </td>
            <td>{{ item.ar[0].name }}</td>
            <td>{{ item.al.name }}</td>
            <td>{{ item.dt }}</td>
          </tr>
          </tbody>
        </table>
      </el-tab-pane>
      <el-tab-pane :label="showSum()" name="2">
        <div class="comment-wrap">
          <p class="title">精彩评论<span class="number">({{ hotCount }})</span></p>
          <div class="comments-wrap">
            <div class="item" v-for="(item,index) in hotComments" :key="index">
              <div class="icon-wrap">
                <img :src="item.user.avatarUrl" alt=""/>
              </div>
              <div class="content-wrap">
                <div class="content">
                  <span class="name">{{ item.user.nickname }}</span>
                  <span class="comment">{{ item.content }}</span>
                </div>
                <div class="re-content" v-if="item.beReplied.length != 0">
                  <span class="name">{{ item.beReplied[0].user.nickname }}</span>
                  <span class="comment">{{ item.beReplied[0].content }}</span>
                </div>
                <div class="date">{{ (new Date(item.time).toLocaleString()) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="comment-wrap">
          <p class="title">最新评论<span class="number">({{ Count }})</span></p>
          <div class="comments-wrap">
            <div class="item" v-for="(item,index) in comments" :key="index">
              <div class="icon-wrap">
                <img :src="item.user.avatarUrl" alt=""/>
              </div>
              <div class="content-wrap">
                <div class="content">
                  <span class="name">{{ item.user.nickname }}</span>
                  <span class="comment">{{ item.content }}</span>
                </div>
                <div class="re-content" v-if="item.beReplied.length != 0">
                  <span class="name">{{ item.beReplied[0].user.nickname }}</span>
                  <span class="comment">{{ item.beReplied[0].content }}</span>
                </div>
                <div class="date">{{ new Date(item.time).toLocaleString() }}</div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :total="total"
            :current-page="page"
            :page-size="5"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'playlist',
  data() {
    return {
      activeIndex: '1',
      total: 0,
      page: 1,
      limit: 15,
      playList: {},
      hotComments: [],
      hotCount: 0,
      comments: [],
      Count: 0
    };
  },

  created() {
    this.getplayList()
    this.gethotComments()
    this.getComments()
  },

  methods: {
    toMvlist(id) {
      this.$router.push('/mv?q=' + id)
    },
    showSum() {
      return '评论(' + this.total + ')'
    },
    playMusic(id) {
      // console.log(id)
      axios({
        url: 'http://120.76.129.1:3000/song/url',
        method: 'get',
        params: {
          id
        }
      }).then(res => {
        // console.log(res)
        console.log(res.data.data[0].url)
        this.musicUrl = res.data.data[0].url
      })
    },
    getplayList() {

      axios({
        url: 'http://120.76.129.1:3000/playlist/detail',
        method: 'get',
        params: {
          id: this.$route.query.q
        }
      }).then(res => {
        console.log(res)
        this.playList = res.data.playlist
        for (let i = 0; i < this.playList.tracks.length; i++) {
          let duration = this.playList.tracks[i].dt
          let min = parseInt(duration / 1000 / 60)
          if (min < 10) {
            min = '0' + min;
          }
          let sec = parseInt(duration / 1000 % 60)
          if (sec < 10) {
            sec = '0' + sec;
          }
          this.playList.tracks[i].dt = `${min}:${sec}`
        }
      })
    },
    gethotComments() {
      axios({
        url: 'http://120.76.129.1:3000/comment/hot',
        method: 'get',
        params: {
          id: this.$route.query.q,
          type: 2
        }
      }).then(res => {
        // console.log(res)
        this.hotComments = res.data.hotComments
        this.hotCount = res.data.total
        this.total = this.Count + this.hotCount
      })
    },
    getComments() {
      axios({
        url: 'http://120.76.129.1:3000/comment/playlist',
        method: 'get',
        params: {
          id: this.$route.query.q,
          offset: (this.page - 1) * this.limit
        }
      }).then(res => {
        // console.log(res)
        this.comments = res.data.comments
        this.Count = res.data.total
        this.total = this.Count + this.hotCount
      })
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val
      // console.log(this.page)
      this.gethotComments()
      this.getComments()
    }
  }
};
</script>

<style>

</style>
